import { Route } from "@angular/router";

import { checkIfLoggedInFn } from "../../../core/guards";
import { PageMode } from "../../../shared/constants/enums";
import { manageDataEntryPagesGuards, manageMonitoringMetricPagesGuards, viewDataEntryPagesGuards } from "../_guards";
import { DataEntryMetricsEditorComponent } from "./data-entry-metrics-editor/data-entry-metrics-editor";
import { DataEntryMetricsListComponent } from "./data-entry-metrics-list/data-entry-metrics-list";

export const DATA_ENTRY_METRICS_ROUTES: Route[] = [
  {
    path: "metrics",
    canActivate: [checkIfLoggedInFn, ...viewDataEntryPagesGuards],
    children: [
      {
        path: "",
        component: DataEntryMetricsListComponent,
        data: {
          breadcrumb: "breadcrumbs.metrics",
          title: "breadcrumbs.metrics",
        },
      },
      {
        path: ":id",
        component: DataEntryMetricsEditorComponent,
        data: {
          breadcrumb: "breadcrumbs.view_metric",
          title: "breadcrumbs.view_metric",
          pageMode: PageMode.view,
        },
      },
      {
        path: "edit/:id",
        component: DataEntryMetricsEditorComponent,
        canActivate: [...manageDataEntryPagesGuards],
        data: {
          breadcrumb: "breadcrumbs.metric_edit",
          title: "breadcrumbs.metric_edit",
          pageMode: PageMode.edit,
          isMonitoring: false,
        },
      },
      {
        path: "realtime/edit/:id",
        component: DataEntryMetricsEditorComponent,
        canActivate: [...manageMonitoringMetricPagesGuards],
        data: {
          breadcrumb: "breadcrumbs.metric_edit",
          title: "breadcrumbs.metric_edit",
          pageMode: PageMode.edit,
          isMonitoring: true,
        },
      },
    ],
  },
];
